<template>
  <div class="leaflet-subunit-box">
    <slot></slot>
    <!-- 骨架图显示控制按钮 -->
    <div v-if="skeletonGraphList.length > 0" class="skeleton-graph-toggle">
      <Checkbox v-model="showSkeletonGraph" @on-change="toggleSkeletonGraph">
        {{ langMap.showSkeletonGraph ? langMap.showSkeletonGraph[lang] : '显示骨架图' }}
      </Checkbox>
    </div>
  </div>
</template>
<script>
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import 'leaflet.pm';
import 'leaflet.pm/dist/leaflet.pm.css';
import markerDefaultBlue from '@/assets/images/map/mark_default_blue.png';
import markerChargingBlue from '@/assets/images/map/mark_charging_blue.png';
import markerChargingGreen from '@/assets/images/map/mark_charging_green.png';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import api from '@/api/index.js';

export default {
  name: 'leafletSubunit',
  props: {
    // 绘制区域用的颜色集
    areaColor: {
      type: Array,
      default: () => ['', '', '']
    },
    addNode: {
      type: Function,
      default: (s) => s
    },
    // 站点ID，用于加载骨架图
    stationId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      langMap:langMap,
      defaultMap: '', //默认地图，高德amap，通用地图leaflet，默认通用地图；
      defaultMapUrl: '', //默认地图url，通用地图默认url
      placeSearch: null,
      map: null,
      line: null,
      currentMarker: null,
      markers: [],
      nodeTypeList: [],
      btnLoading: false,
      saveModal: false,
      nodeList: [],
      tableLoading: false,
      pendingMapClickHandler: null,
      // 骨架图相关
      showSkeletonGraph: false, // 是否显示骨架图
      skeletonGraphList: [], // 骨架图列表
      skeletonGraphLayers: {}, // 骨架图图层 { graphId: layerGroup }
      skeletonNodeMarkers: {}, // 骨架图节点标记 { graphId: [markers] }
      skeletonEdgeLines: {}, // 骨架图连线 { graphId: [lines] }
      skeletonEdgeDecorators: {}, // 骨架图箭头装饰器 { graphId: [decorators] }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      mapConfig: state => state.app.leafletConfig
    }),
  },
  methods: {
    //初始化地图
    initMap(mapKey,mapUrl) {
      const tileLayerOption = this.mapConfig.tileLayerOption
      this.map = L.map("task_map_id", this.mapConfig.mapInstantiated);
      L.tileLayer(tileLayerOption.url, tileLayerOption).addTo(this.map);

      //添加绘制控制组件
      this.map.pm.setLang(this.lang || 'zh');
      this.map.pm.addControls({
        position: 'topleft',
        drawPolygon: false, // 绘制多边形
        drawMarker: false, //绘制标记点
        drawCircleMarker: false, //绘制圆形标记
        drawPolyline: false, //绘制线条
        drawRectangle: false, //绘制矩形
        drawCircle: false, //绘制圆圈
        editMode: false, //编辑多边形
        dragMode: false, //拖动多边形
        cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
        removalMode: false // 清除多边形
      });
    },
    //初始化绘制区域
    initTargetArea(areaList) {
      const dataList = areaList || [];

      dataList.forEach((item, index) => {
        if (item.area !== null) {
          let color = this.areaColor[item.type];

          let areas = JSON.parse(item.area);
          let areaTemp = [];
          areas.forEach((item1, index1, arr1) => {
            let point = [item1.lat, item1.lon];
            areaTemp[index1] = point;
          });
          console.info('[dataList>>>]', areaTemp);
          let polygon = L.polygon(areaTemp, {
            color: color,
            id: item.id
          }).addTo(this.map);
        }
      });
    },
    //初始化任务规划
    initPath(dataList) {
      // 修复：先清除所有旧的 Marker 和 Line，防止重复和连线错乱
      this.markers.forEach(marker => {
        this.map.removeLayer(marker);
      });
      this.markers = [];
      
      if (this.line) {
        this.map.removeLayer(this.line);
        this.line = null;
      }
      
      this.nodeList = JSON.parse(JSON.stringify(dataList));
      // 绘制点、线、设置中心
      this.nodeList.forEach((item, index) => {
        if (item.lat !== null && item.lng !== null) {
          this.createMarker([item.lat, item.lng], item);
        }
      });
      this.createLine();
    },
    moveToCenter(point) {
      this.map.panTo([point[1], point[0]]);
    },
    //创建节点，添加移动事件，链接点之间的线
    createMarker(point, item) {
      console.info('[marker]', item);
      let icon = new L.divIcon({
        html: '<div style="width: 100px;font-size: 16px;font-weight: 700;color: #9e59a3;">' + item.name + '</div><img src="' + markerChargingBlue + '" style="width: 15px;height: 15px;" />',
        className: 'my-div-icon',
        iconAnchor: [6, 28],
      });
      let marker = L.marker(point, {
        icon: icon,
        title: item.name,
        draggable: true,
        'id': item.tempId,
      }).addTo(this.map);
      this.markers.push(marker);

      // 点位拖动事件
      let _this = this;
      marker.on("dragend", function (e) {
        _this.updateMarkerPoint(marker.getLatLng(), item.tempId, 'map');
        // 移动线位置
        _this.redrawLine();
      });

      //弹出信息层
      marker.on('click', function (e) {
        _this.createPopup(item.tempId);
      });
      return marker;
    },
    createPopup(tempId) {
      let node;
      this.nodeList.forEach((item, index, arr) => {
        if (item.tempId === tempId) {
          node = item;
        }
      });
      if (node && node.lng && node.lat) {
        const _desc = node.description || '';
        let typeStr = node.typeStr ? node.typeStr : '';
        let content = '<div class="input-card content-window-card"><div style="padding:7px 0px 0px 0px;">'
          + '<h4>' + langMap.name[this.lang] + '：' + node.name + '</h4>'
          + '<p class="input-item">' + langMap.description[this.lang] + '：' + _desc + '</p>'
          + '</div></div>';

        let popup = L.popup({ offset: [0, -15] })
          .setLatLng([node.lat, node.lng])
          .setContent(content);
        popup.openOn(this.map);
      }
    },
    // 获取点集合
    getMarkerPoints() {
      let markerPoints = [];
      this.nodeList.forEach((item, index, arr) => {
        if (item.lat !== null && item.lng !== null) {
          markerPoints.push([item.lat, item.lng]);
        }
      });
      return markerPoints;
    },
    //绘制线
    createLine() {
      let markerPoints = this.getMarkerPoints();
      this.line = L.polyline(markerPoints, {
        opacity: 1, //透明度
        color: "#000"
      }).addTo(this.map);
    },
    //更新点位置
    updateMarkerPoint(point, id, source = null) {
      this.nodeList.forEach((item, index, arr) => {
        //通过临时tempId查找
        if (item.tempId === id) {
          item.lat = point.lat;
          item.lng = point.lng;
          if (source) {
            item.coordinateSource = source;
          }
          this.$set(this.nodeList, index, item);
        }
      });
      this.$emit('updateNodeList', this.nodeList);
    },
    //重绘制线条
    redrawLine() {
      if (this.line) {
        let markerPoints = this.getMarkerPoints();
        this.line.setLatLngs(markerPoints);
        this.line.redraw();
      } else {
        this.createLine();
      }
    },
    //点击按钮添标记点，每次追加
    addMarker(row) {
      this.currentMarker = null;
      if (this.pendingMapClickHandler) {
        this.map.off('click', this.pendingMapClickHandler);
        this.pendingMapClickHandler = null;
      }
      const handler = (i) => {
        if (this.currentMarker == null && (row.lat === null || row.lat === '' || row.lng === null || row.lng === '')) {
          //创建 marker点
          let lat, lng;
          lat = i.latlng.lat;
          lng = i.latlng.lng;
          this.currentMarker = this.createMarker([lat, lng], row);

          // 修复：不要调用 addNode 重复插入，而是找到现有节点并更新坐标
          const existingNode = this.nodeList.find(n => n.tempId === row.tempId);
          if (existingNode) {
            existingNode.lat = lat;
            existingNode.lng = lng;
            existingNode.coordinateSource = 'map';
          } else {
            // 如果确实不存在，才插入（理论上不应该走到这里）
            this.addNode(this.nodeList, row);
          }

          this.$emit('updateNodeList', this.nodeList);
          //重绘线
          this.redrawLine();
          this.map.off('click', handler);
          this.pendingMapClickHandler = null;
        }
      };
      this.pendingMapClickHandler = handler;
      this.map.on('click', handler);
    },

    //删除节点
    delMarker(row) {
      this.nodeList.forEach((item, index, arr) => {
        //通过临时tempId查找
        if (item.tempId === row.tempId) {
          this.nodeList.splice(index, 1);
          //删除marker
          this.markers.forEach((item1, index1, arr1) => {
            if (item1.options.id === item.tempId) {
              this.map.removeLayer(item1);
            }
          });
        }
      });
      //重新编排序号
      this.nodeList.forEach((item, index, arr) => {
        item.nodeOrder = index + 1;
        this.$set(this.nodeList, index, item);
      });
      this.$emit('updateNodeList', this.nodeList);
      //重绘线
      this.redrawLine();
    },

    // ==================== 骨架图相关方法 ====================
    
    // 加载骨架图数据
    async loadSkeletonGraphs() {
      if (!this.stationId) {
        console.log('No stationId provided, skipping skeleton graph loading');
        return;
      }

      try {
        const res = await api.getData(`task-server/skeletonGraph/list?stationId=${this.stationId}`, this);
        
        if (res.state != 0) {
          const graphList = res.data || [];
          this.skeletonGraphList = graphList;
          console.log('Loaded skeleton graphs:', graphList.length);
        }
      } catch (error) {
        console.error('加载骨架图失败:', error);
      }
    },

    // 渲染骨架图
    renderSkeletonGraphs() {
      if (!this.showSkeletonGraph || !this.skeletonGraphList.length) {
        return;
      }

      // 清除旧的骨架图图层
      this.clearSkeletonGraphLayers();

      // 渲染每个骨架图
      this.skeletonGraphList.forEach(graph => {
        this.renderSingleSkeletonGraph(graph);
      });
    },

    // 渲染单个骨架图
    renderSingleSkeletonGraph(graph) {
      if (!graph.nodes || graph.nodes.length === 0) return;

      const graphId = graph.id;
      
      // 创建图层组
      const layerGroup = L.layerGroup().addTo(this.map);
      this.skeletonGraphLayers[graphId] = layerGroup;
      this.skeletonNodeMarkers[graphId] = [];
      this.skeletonEdgeLines[graphId] = [];

      // 渲染边（先渲染边，这样节点会在上层）
      if (graph.edges && graph.edges.length > 0) {
        this.renderSkeletonEdges(graph.edges, graphId, graph);
      }

      // 渲染节点
      graph.nodes.forEach(node => {
        this.createSkeletonNodeMarker(node, graphId);
      });
    },

    // 创建骨架图节点标记
    createSkeletonNodeMarker(node, graphId) {
      // 使用原始的 GCJ02 坐标（lat/lon 或 latitude/longitude），与骨架图查看页面一致
      const lat = node.lat || node.latitude;
      const lon = node.lon || node.longitude;

      if (!lat || !lon) return;

      // 使用蓝色图标，与骨架图查看页面一致
      const icon = new L.divIcon({
        html: `<img src="${markerDefaultBlue}" style="width: 15px;height: 15px;opacity: 0.8;" />`,
        className: 'skeleton-node-marker',
        iconAnchor: [7, 7],
      });

      const marker = L.marker([lat, lon], {
        icon: icon,
        title: `Node ${node.id}`,
        draggable: false, // 不可拖动
        nodeId: node.id,
        graphId: graphId,
        interactive: false // 不可交互
      }).addTo(this.skeletonGraphLayers[graphId]);

      this.skeletonNodeMarkers[graphId].push(marker);
      return marker;
    },

    // 渲染骨架图边
    renderSkeletonEdges(edges, graphId, graph) {
      const nodes = graph.nodes;
      const nodeMap = {};
      nodes.forEach(node => {
        nodeMap[node.id] = node;
      });

      edges.forEach(edge => {
        this.createSkeletonEdgeLine(edge, nodeMap, graphId);
      });
    },

    // 创建骨架图边线
    createSkeletonEdgeLine(edge, nodeMap, graphId) {
      const fromNodeId = edge.fromNodeId || edge.from;
      const toNodeId = edge.toNodeId || edge.to;
      const fromNode = nodeMap[fromNodeId];
      const toNode = nodeMap[toNodeId];

      if (!fromNode || !toNode) return;

      // 使用原始的 GCJ02 坐标，与骨架图查看页面一致
      const fromLat = fromNode.lat || fromNode.latitude;
      const fromLon = fromNode.lon || fromNode.longitude;
      const toLat = toNode.lat || toNode.latitude;
      const toLon = toNode.lon || toNode.longitude;

      if (!fromLat || !fromLon || !toLat || !toLon) return;

      const points = [
        [fromLat, fromLon],
        [toLat, toLon]
      ];

      // bidirectional: 1=双向，0=单向
      const color = edge.bidirectional === 0 ? '#ff9800' : '#1890ff';
      const opacity = 0.8; // 稍微透明
      
      const line = L.polyline(points, {
        color: color,
        weight: 3,
        opacity: opacity,
        edgeId: `${fromNodeId}-${toNodeId}`,
        graphId: graphId,
        interactive: false // 不可交互
      });

      line.addTo(this.skeletonGraphLayers[graphId]);
      this.skeletonEdgeLines[graphId].push(line);

      // 添加箭头装饰器（使用 SVG 标记）
      this.addSkeletonArrowDecorator(line, edge.bidirectional === 1, color, graphId);

      return line;
    },

    // 清除骨架图图层
    clearSkeletonGraphLayers() {
      Object.keys(this.skeletonGraphLayers).forEach(graphId => {
        if (this.skeletonGraphLayers[graphId]) {
          this.map.removeLayer(this.skeletonGraphLayers[graphId]);
        }
      });
      this.skeletonGraphLayers = {};
      this.skeletonNodeMarkers = {};
      this.skeletonEdgeLines = {};
      this.skeletonEdgeDecorators = {};
    },

    // 切换骨架图显示
    toggleSkeletonGraph(show) {
      this.showSkeletonGraph = show;
      if (show) {
        this.renderSkeletonGraphs();
      } else {
        this.clearSkeletonGraphLayers();
      }
    },

    // 添加箭头装饰器（使用 SVG 标记）
    addSkeletonArrowDecorator(line, isBidirectional, color, graphId) {
      // 计算线段中点位置
      const latlngs = line.getLatLngs();
      if (latlngs.length < 2) return;

      const start = latlngs[0];
      const end = latlngs[latlngs.length - 1];
      
      // 获取edgeId
      const edgeId = line.options.edgeId;
      
      // 初始化箭头存储
      if (!this.skeletonEdgeDecorators[graphId]) {
        this.skeletonEdgeDecorators[graphId] = {};
      }
      
      // 清除旧箭头
      if (this.skeletonEdgeDecorators[graphId][edgeId]) {
        this.skeletonEdgeDecorators[graphId][edgeId].forEach(arrow => {
          this.skeletonGraphLayers[graphId].removeLayer(arrow);
        });
      }
      
      this.skeletonEdgeDecorators[graphId][edgeId] = [];
      
      // 计算角度（使用屏幕坐标）
      const map = this.map;
      const startPoint = map.latLngToContainerPoint(start);
      const endPoint = map.latLngToContainerPoint(end);
      
      const dx = endPoint.x - startPoint.x;
      const dy = endPoint.y - startPoint.y;
      const angle = Math.atan2(dy, dx) * 180 / Math.PI;
      
      const opacity = 0.8; // 稍微透明
      
      if (isBidirectional) {
        // 双向连线：在中间位置添加两个相对的箭头
        const midLat = (start.lat + end.lat) / 2;
        const midLng = (start.lng + end.lng) / 2;
        
        const offsetX = 7;
        const offsetY = 0;
        
        // 第一个箭头（指向终点）
        const arrow1Icon = L.divIcon({
          html: `<div style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; transform: rotate(${angle}deg) translate(${offsetX}px, -${offsetY}px); opacity: ${opacity};">
                   <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path d="M12 4 L20 12 L12 20 L12 14 L4 14 L4 10 L12 10 Z" fill="${color}" stroke="white" stroke-width="1"/>
                   </svg>
                 </div>`,
          className: 'arrow-decorator',
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        });
        
        const arrow1Marker = L.marker([midLat, midLng], {
          icon: arrow1Icon,
          interactive: false,
          keyboard: false
        });
        arrow1Marker.addTo(this.skeletonGraphLayers[graphId]);
        this.skeletonEdgeDecorators[graphId][edgeId].push(arrow1Marker);
        
        // 第二个箭头（指向起点，旋转180度）
        const arrow2Icon = L.divIcon({
          html: `<div style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; transform: rotate(${angle + 180}deg) translate(${offsetX}px, -${offsetY}px); opacity: ${opacity};">
                   <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path d="M12 4 L20 12 L12 20 L12 14 L4 14 L4 10 L12 10 Z" fill="${color}" stroke="white" stroke-width="1"/>
                   </svg>
                 </div>`,
          className: 'arrow-decorator',
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        });
        
        const arrow2Marker = L.marker([midLat, midLng], {
          icon: arrow2Icon,
          interactive: false,
          keyboard: false
        });
        arrow2Marker.addTo(this.skeletonGraphLayers[graphId]);
        this.skeletonEdgeDecorators[graphId][edgeId].push(arrow2Marker);
      } else {
        // 单向连线：在靠近起点的位置添加一个箭头指向终点
        const arrowLat = start.lat + (end.lat - start.lat) * 0.35;
        const arrowLng = start.lng + (end.lng - start.lng) * 0.35;
        
        const arrowIcon = L.divIcon({
          html: `<div style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; transform: rotate(${angle}deg); opacity: ${opacity};">
                   <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path d="M12 4 L20 12 L12 20 L12 14 L4 14 L4 10 L12 10 Z" fill="${color}" stroke="white" stroke-width="1"/>
                   </svg>
                 </div>`,
          className: 'arrow-decorator',
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        });
        
        const arrowMarker = L.marker([arrowLat, arrowLng], {
          icon: arrowIcon,
          interactive: false,
          keyboard: false
        });
        arrowMarker.addTo(this.skeletonGraphLayers[graphId]);
        this.skeletonEdgeDecorators[graphId][edgeId].push(arrowMarker);
      }
    }
  },
  
  async mounted() {
    // 加载骨架图数据
    await this.loadSkeletonGraphs();
  }
}
</script>
<style scoped>
.leaflet-subunit-box{
  height: 100%;
  position: relative;
}

/* 骨架图显示控制按钮 */
.skeleton-graph-toggle {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background: white;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 骨架图节点标记样式 */
.skeleton-node-marker {
  background-color: transparent;
  border: 0;
  opacity: 0.8;
}

/* 箭头装饰器样式 */
.arrow-decorator {
  background-color: transparent;
  border: 0;
}
</style>
